import React, { Component, useEffect, useState } from 'react';
import CountUp from 'react-countup';
import { connect } from 'react-redux';
import axios from 'axios';
import Select from "react-select";
import { Redirect } from 'react-router-dom';
import { useHistory } from "react-router-dom";


import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { API_BASE_URL } from '../../config.js'
import DataTable, { defaultThemes } from 'react-data-table-component';

import Pagination from '../Pagination/Paginations.js';
import EntriesSelector from '../Pagination/EntriesSelector';
import useSortData from "../Pagination/SortData";


import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';

// import DataTable from 'datatables.net-react';
// import DT from 'datatables.net-dt';

// DataTable.use(DT);
import {
	statisticsAction,
	statisticsCloseAction
} from '../../actions/settingsAction.js';
import { Link } from 'react-router-dom/cjs/react-router-dom.min.js';
const HodManPower = (props) => {
	const sparkline1 = React.createRef();
	const sparkline2 = React.createRef();
	const sparkline3 = React.createRef();
	const sparkline4 = React.createRef();


	const handleStatistics = (e) => {
		statisticsAction(e)
	}
	const closeStatistics = (e) => {
		statisticsCloseAction(e)
	}

	const { fixNavbar, statisticsOpen, statisticsClose } = props;
	
	
	const today = new Date().toISOString().split("T")[0];


	const [user, setUser] = useState({
        department_name:"",
        department:"",
        current_manpower:"",
        extra_manpower: "",
        dept_manpower: "",
        reason:"",
    })


     const [toggle,setToggle]=useState(false);
	

	
	const history = useHistory();
	const [data, setData]= useState([]);
	const [dataval, setdataval]= useState([]);
    const [isVisible, setIsVisible] = useState(false);
	const [urlres, setUrlRes] = useState(false);
	const [style1,setStyle1]=useState(false);
	const [records, setRecords] = useState([]);
	const [loading, setLoading] = useState(false);

	const { sortConfig, sortData, handleSort } = useSortData();


    const handelInput = (event) => {
        event.preventDefault();
        const { name, value } = event.target;
        console.log(name, value)
        setUser({ ...user, [name]: value });

        if (event.target.value === '1') {
            setIsVisible(true);
          } else {
            setIsVisible(false);
          }
    }


    

    const [department, setDepartmentValue] = useState("");
    const [currentmanpower, setCurrentManPowerValue] = useState("");



  const handleDropdownChange = (event) => {
    
    const value = event.target.value;
    setDepartmentValue(value);
   

    axios.get(API_BASE_URL +'/count_department/'+value, {
		headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
	})

    // .then(response => {
    //     console.log(response.data[0].week_count); // Assuming response has a "text" field
    // })

    .then(response => {
        setCurrentManPowerValue(response.data[0].week_count); // Assuming response has a "text" field
    })
    .catch(error => console.error("Error fetching text:", error));

    // Update textbox value based on dropdown selection
   
  };


	


  		const [searchTerm, setSearchTerm] = useState("");
		const [currentPage, setCurrentPage] = useState(1);
		const [entriesPerPage,setEntriesPerPage]=useState(10);
		const filteredItems = records.filter((item) => {
  const search = searchTerm.toLowerCase();

  return (
    String(item.department_name ?? "").toLowerCase().includes(search) ||
    String(item.current_manpower ?? "").includes(search) ||
    String(item.extra_manpower ?? "").includes(search) ||
    String(item.incharge_reason ?? "").toLowerCase().includes(search) ||
    String(item.date ?? "").includes(search)
  );
});
		const totalPages = Math.ceil(filteredItems.length / entriesPerPage);
		const indexOfLast = currentPage * entriesPerPage;
		const indexOfFirst = indexOfLast - entriesPerPage;
		// const filteredData = filteredItems.slice(indexOfFirst, indexOfLast);

		const sortedItems = sortData(filteredItems);
		const filteredData = sortedItems.slice(indexOfFirst, indexOfLast);
	  
		useEffect(() => {
		  setCurrentPage(1);
		}, [searchTerm]);
	  
		
	
	  const handleSearch = (event) => {
		//console.log(event.target.value);
		 setSearchTerm(event.target.value);
	  };
	

	  const clearInput = () => {
		setSearchTerm("");
	  };
	 


  useEffect(()=> {
	axios.get(API_BASE_URL +'/showallemployee', {
		headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
	})

	// .then(res =>console.log(res.data.user_det))
	 .then(res => setData(res.data.user_det))
	.catch(err => console.log(err));
},[])



useEffect(()=> {
	axios.get(API_BASE_URL +'/incharge_manpower_request', {
		headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
	})

	// .then(res =>console.log(res.data.user_det))
	 .then(res => setRecords(res.data.manpower))
	.catch(err => console.log(err));
},[])



const handleUpdate = async (id) => {

	axios.get(API_BASE_URL + '/manpower_request_list/' + id, {
		headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
	})
    // .then(res1 => console.log(res1.data[0]))
		.then(res1 => setUser(res1.data[0]))
		.catch(err => console.log(err))
};



    // useEffect(() => {
    //     handleUpdate();
    // }, []);







	const handleEditSubmit = (e) => {

		e.preventDefault();
		
		axios.post(API_BASE_URL + '/hod_update_manpower_request', { dept_manpower: user.dept_manpower, dept_reason: user.reason, id:user.id }, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		}).then(response => {
			// console.log(response.data);
			// // 	console.log(response.data.message);
			//  })

			var status = response.data.status;

			if (status == 200) {
				toast.success(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});

				const timeout = setTimeout(() => {
					window.location.reload(); // Reload the current page
				}, 5000); // Refresh after 5 seconds

				return () => {
					clearTimeout(timeout); // Cleanup the timeout if the component unmounts
				};

			} else if (status == 401) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}
			else if (status == 400) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}


		}).catch(error => {
			// console.log(error);
			// console.log(error.response.data.message);




			toast.error(error.response.data.message, {
				position: "bottom-right",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "colored",


			});

		});
	};

	


	useEffect(()=> {
		axios.get(API_BASE_URL +'/head_all_departments', {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})
	
		//.then(res =>console.log(res.data))
		 .then(res => setdataval(res.data))
		.catch(err => console.log(err));
	},[])


		const columns = [
  { label: "Department Name", key: "department_name", sortable: true },
  { label: "Current Manpower", key: "current_manpower", sortable: true },
  { label: "Manpower Requested", key: "extra_manpower", sortable: true },
  { label: "Reason", key: "incharge_reason", sortable: true },
  { label: "Date", key: "date", sortable: true },
];

	
	return (
		<>


			<div>
				<div>
					<div className={`section-body ${fixNavbar ? "marginTop" : ""} `}>
						<div className="container-fluid">

							<ToastContainer />
						
						</div>
					</div>


                    

					


										<div className="section-body">
											<div className="container-fluid">
												<div className="tab-content">
													<div className="tab-pane fade show active" id="Employee-list" role="tabpanel">
														<div className="card">
					
															<div className="card-header">
																<h3 className="card-title" style={{color:'#e96827'}}></h3>
																<div
  className="card-options"
  style={{
    display: "flex",
    alignItems: "center",
    gap: "12px",
  }}
>
  <EntriesSelector
    entriesPerPage={entriesPerPage}
    setEntriesPerPage={setEntriesPerPage}
    setCurrentPage={setCurrentPage}
  />

  {/* 🔽 SEARCH BOX WRAPPER */}
  <div style={{ position: "relative", width: "200px" }}>
    <input
      type="text"
      className="form-control form-control-sm"
      placeholder="Search"
      value={searchTerm}
      onChange={(e) => {
        setSearchTerm(e.target.value);
        setCurrentPage(1);
      }}
      style={{
        width: "100%",
        height: "30px",
        fontSize: "13px",
        borderRadius: "4px",
        paddingRight: "28px", // ✅ space for X
      }}
    />

    {searchTerm.length > 0 && (
      <span
        onClick={clearInput}
        style={{
          position: "absolute",
          right: "8px",        // ✅ INSIDE input
          top: "50%",          // ✅ vertically centered
          transform: "translateY(-50%)",
          cursor: "pointer",
          color: "#aaa",
          fontSize: "16px",
          userSelect: "none",
        }}
      >
        ✖
      </span>
    )}
  </div>
</div>
															</div>
					
															{/* <div>
																<DataTable 
																columns={column} 
																data={data}
																customStyles={customStyles}
																pagination 
																highlightOnHover
																responsive
																paginationPerPage={10}
																paginationRowsPerPageOptions={[25,50,100,500]}
																className="table table-striped table-bordered"> 
															</DataTable>
															</div> */}
					
					
					
					
					
					
					
					{/* Loading Spinner */}
					{loading && (
																<div className="card-body">
																<div class="d-flex justify-content-center">
						   <div class="spinner"></div>
						   </div>
						   </div>
						  )}
					
					{!loading && (
															<div className="card-body">
															
																<div className="table-responsive">
							
					
						
						  
								<table className="table table-hover table-striped table-vcenter text-nowrap mb-0">
																		<thead>
																			<tr>
																				<th>Action</th>
																				 {columns.map((col) => (
																<th
																	key={col.key}
																	onClick={col.sortable ? () => handleSort(col.key) : null}
																	style={{ cursor: col.sortable ? "pointer" : "default" }}
																>
																	{col.label}
																	{col.sortable && (
																sortConfig.key === col.key
																	? (sortConfig.direction === "asc" ? " ▲" : " ▼")
																	: " ⇅"   // <-- DEFAULT SORT ICON
																)}
																	</th>
																))}
																				
																				
																			</tr>
																		</thead>
																		<tbody>
																		{filteredData.length > 0 ? (
																				filteredData.map((record,index) => {
                                                                                  
																					let action;
																					
																					
                                                           
                                                              if (record.dept_status ==1 ){
                                                                    action = '';
                                                                  } else {
                                                                    action = <button
                                                                    type="button" onClick={() =>{ handleUpdate(record.id)}}
                                                                    className="btn btn-icon btn-sm"
                                                                    title="Edit" data-toggle="modal"
                                                                    data-target="#exampleEditModal1"
                                                                >
                                                                    <i className="fa fa-edit" />
                                                                </button>;
																  }
                                                               return(
                                                                                    
                                                               

																					<tr key={`${record.department_name}-${record.date}-${index}`}>

                                                                                    
                                                                                    <td>{action}</td>

                                                                                    
																					
																					<td>{record.department_name}</td>
																					<td>{record.current_manpower}</td>
																					<td>{record.extra_manpower}</td>
																					<td>{record.incharge_reason}</td>
																					<td>{record.date}</td>
																				
																				</tr>
                                                               )
																				
})
																			) : (
																				<tr>
																				<td colSpan="7" style={{ color: 'red', textAlign: 'center',fontWeight: "bold" }}>No records found</td>
																				</tr>
																			)}
					
																
																		</tbody>
																	</table>
																</div>
															
												<Pagination
												currentPage={currentPage}
												totalPages={totalPages}
												onPageChange={setCurrentPage}
												/>
													
					
															</div> 
					)
					}
														</div>
													</div>
						
												
												</div>
											</div>
										</div>

				</div>
			</div>



            <div
				className="modal fade"
				id="exampleEditModal1"
				tabIndex={-1}
				role="dialog"
				aria-labelledby="exampleModalLabel"
				aria-hidden="true"
			>
				<form onSubmit={handleEditSubmit}>
					<div className="modal-dialog" role="document">
						<div className="modal-content">
							<div className="modal-header">
								<h5 className="modal-title" id="exampleModalLabel">
									Update Manpower Request
								</h5>
								<button type="button" className="close" data-dismiss="modal" aria-label="Close">
									<span aria-hidden="true">×</span>
								</button>
							</div>
							<div className="modal-body">
								<div className="row clearfix">
								<div className="col-md-12 col-sm-6">
									<div className="form-group">
                                    <label className="form-label">Department <span className="form-required">*</span></label>
									<input type="text" className="form-control" name="department_name" value={user.department_name} readOnly /> 

									<input name="department" value={user.department} type="hidden" />
                                    <input name="id" value={user.id} type="hidden" />
									</div>
									</div>


                                    <div className="col-md-6 col-sm-6">
										<div className="form-group">
                                        <label className="form-label">Current Manpower <span className="form-required">*</span></label>
										<input type="text" className="form-control" name="currentmanpower" value={user.current_manpower}
													readOnly />
									    </div>
									</div>


                                    <div className="col-md-6 col-sm-6">
										<div className="form-group">
                                        <label className="form-label">Incharge Requested Manpower <span className="form-required">*</span></label>
										<input type="text" className="form-control" name="extra_manpower" value={user.extra_manpower}
													readOnly />
									</div>
									</div>

									<div className="col-md-6 col-sm-6">
										<div className="form-group">
                                        <label className="form-label">Hod Manpower Request <span className="form-required">*</span></label>
											<input type="text" className="form-control" name="dept_manpower" value={user.dept_manpower}
													onChange={handelInput} />
										</div>
									</div>


                                    <div className="col-md-6 col-sm-6">
                                                            <div className="form-group">
                                                            <label className="form-label">Reason <span className="form-required">*</span></label>

                                                            <textarea
                                                            id="textarea"
                                                            name="reason"
                                                            value={user.reason} // Bind the value to state
                                                            onChange={handelInput} // Update state on change
                                                            placeholder=""
                                                            rows="2" // Number of rows (optional)
                                                            cols="20" // Number of columns (optional)
                                                        ></textarea>
                                                        
                                                        </div>
                                                    </div>


                                    
									

								</div>
							</div>
							<div className="modal-footer">
								<button type="button" className="btn btn-secondary" data-dismiss="modal">
									Close
								</button>
								<button type="submit" className="btn btn-primary">
									Update
								</button>
							</div>
						</div>
					</div>

				</form>

			</div>





		




		</>
	);

}



const mapStateToProps = (state) => ({
	fixNavbar: state.settings.isFixNavbar,
	statisticsOpen: state.settings.isStatistics,
	statisticsClose: state.settings.isStatisticsClose,
})

const mapDispatchToProps = (dispatch) => ({
	statisticsAction: (e) => dispatch(statisticsAction(e)),
	statisticsCloseAction: (e) => dispatch(statisticsCloseAction(e))
})
export default connect(mapStateToProps, mapDispatchToProps)(HodManPower);